<!-- Lists -->
@if (fieldHasList) {
  @switch (field.list.type) {
    @case (listType.dropdown) {
      <app-dropdown-field
        #fieldComponent
        [form-control]="control()"
        [field]="field"
        [mv-field-menu]="mvFieldMenu"
        [addRequiredValidator]="addRequiredValidator()"
        [addRegexValidator]="addRegexValidator()"
        (fieldFocused)="onFieldFocused()"
        (fieldBlurred)="onFieldBlurred()"
      ></app-dropdown-field>
    }
    @case (listType.typeahead) {
      <app-typeahead-field
        #fieldComponent
        [form-control]="control()"
        [field]="field"
        [mv-field-menu]="mvFieldMenu"
        [addRequiredValidator]="addRequiredValidator()"
        [addRegexValidator]="addRegexValidator()"
        (fieldFocused)="onFieldFocused()"
        (fieldBlurred)="onFieldBlurred()"
      ></app-typeahead-field>
    }
  }
} @else {
  @switch (field.type) {
    @case (fieldDataType.character) {
      <app-character-field
        #fieldComponent
        [allowTextArea]="true"
        [form-control]="control()"
        [field]="field"
        [mv-field-menu]="mvFieldMenu"
        [addRequiredValidator]="addRequiredValidator()"
        [addRegexValidator]="addRegexValidator()"
        (fieldFocused)="onFieldFocused()"
        (fieldBlurred)="onFieldBlurred()"
      ></app-character-field>
    }
    @case (fieldDataType.integer) {
      <app-number-field
        #fieldComponent
        [form-control]="control()"
        [field]="field"
        [mv-field-menu]="mvFieldMenu"
        [addRequiredValidator]="addRequiredValidator()"
        [addRegexValidator]="addRegexValidator()"
        (fieldFocused)="onFieldFocused()"
        (fieldBlurred)="onFieldBlurred()"
      ></app-number-field>
    }
    @case (fieldDataType.decimal) {
      <app-decimal-field
        #fieldComponent
        [form-control]="control()"
        [field]="field"
        [mv-field-menu]="mvFieldMenu"
        [addRequiredValidator]="addRequiredValidator()"
        [addRegexValidator]="addRegexValidator()"
        (fieldFocused)="onFieldFocused()"
        (fieldBlurred)="onFieldBlurred()"
      ></app-decimal-field>
    }
    @case (fieldDataType.date) {
      <app-date-field
        #fieldComponent
        [form-control]="control()"
        [field]="field"
        [mv-field-menu]="mvFieldMenu"
        [addRequiredValidator]="addRequiredValidator()"
        [addRegexValidator]="addRegexValidator()"
        (fieldFocused)="onFieldFocused()"
        (fieldBlurred)="onFieldBlurred()"
      >
      </app-date-field>
    }
  }
}

<!-- Non lists -->
